import PagesGrid from '../components/Grid';
import { PageProvider } from '../store';

export default function PagesGridLayout() {
  return <PageProvider>
    <PagesGrid />
  </PageProvider>
}
